// The schedule page controller (ARCHITECTURE §5.2). Registered by
// core/pages/controllers.ts; classic's Schedule view consumes its VM.
import { useSchedulePage } from './useSchedulePage'

export default function useScheduleController() {
  // Every template lists the season's games outside any competition (#478).
  return useSchedulePage(undefined, { seasonGames: true })
}
